import { apiConstants } from "../config";
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), "")}.home`,
                    text: "home.title",
                    icon: "fas fa-home"
                },
                acl: {
                    view: "CEM_10001"
                }
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: `settings.titles`,
                    icon: "fas fa-cogs"
                },
                acl: {
                    view: false,
                    edit: false
                },
                url: {
                    getConfig: `/${codeAPI}/gestao/definitions`
                }
            },
            default_layers: {
                menu: {
                    route: `${code}.default_layers`,
                    text: "default_layers.titles",
                    icon: "fas fa-layer-group"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/defaultlayers`,
                    getShow: `${codeAPI}/gestao/defaultlayers/:id`,
                    getCreate: `${codeAPI}/gestao/defaultlayers`,
                    getUpdate: `${codeAPI}/gestao/defaultlayers/:id`,
                    getDelete: `${codeAPI}/gestao/defaultlayers/:id`,
                    getLists: `${codeAPI}/gestao/defaultlayers/lists`,
                    getResources: `${codeAPI}/gestao/defaultlayers/resources`,
                }
            },
            layers: {
                menu: {
                    route: `${code}.layers`,
                    text: `layers.titles`,
                    icon: "fas fa-layer-group"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                    private: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/layers`,
                    getShow: `${codeAPI}/gestao/layers/:id`,
                    getCreate: `${codeAPI}/gestao/layers`,
                    getUpdate: `${codeAPI}/gestao/layers/:id`,
                    getDelete: `${codeAPI}/gestao/layers/:id`,
                    getLists: `${codeAPI}/gestao/layers/lists`,
                    getResources: `${codeAPI}/gestao/layers/resources`,
                    describeResource: `${codeAPI}/gestao/layers/resources/:id/describe`,
                }
            },
            regulations: {
                menu: {
                    route: `${code}.regulations`,
                    text: `regulations.titles`,
                    icon: "fas fa-book"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/regulations`,
                    getShow: `${codeAPI}/gestao/regulations/:id`,
                    getCreate: `${codeAPI}/gestao/regulations`,
                    getUpdate: `${codeAPI}/gestao/regulations/:id`,
                    getDelete: `${codeAPI}/gestao/regulations/:id`,
                    getLists: `${codeAPI}/gestao/regulations/lists`
                }
            },
            print_visible_emissions: {
                menu: {
                    route: `${code}.print_visible_emissions.config`,
                    text: `print_visible_emissions.titles`,
                    icon: "fas fa-print"
                },
                acl: {
                    view: false,
                    config: false,
                    configEdit: false
                },
                url: {
                    getList: `/${codeAPI}/gestao/printvisible`,
                    getConfig: `/${codeAPI}/gestao/printvisible/settings`,
                    getApps: `/${codeAPI}/gestao/printvisible/print/apps`
                }
            },
            cause_death_types: {
                menu: {
                    route: `${code}.cause_death_types`,
                    text: `cause_death_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/causedeathtypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/causedeathtypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/causedeathtypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/causedeathtypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/causedeathtypes/:id`
                }
            },
            document_location_types: {
                menu: {
                    route: `${code}.document_location_types`,
                    text: `document_location_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/documentlocationtypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/documentlocationtypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/documentlocationtypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/documentlocationtypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/documentlocationtypes/:id`
                }
            },
            document_types: {
                menu: {
                    route: `${code}.document_types`,
                    text: `document_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/documenttypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/documenttypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/documenttypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/documenttypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/documenttypes/:id`
                }
            },
            genders: {
                menu: {
                    route: `${code}.genders`,
                    text: `genders.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/genders`,
                    getShow: `${codeAPI}/gestao/cemeteries/genders/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/genders`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/genders/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/genders/:id`
                }
            },

            occupation_position_types: {
                menu: {
                    route: `${code}.occupation_position_types`,
                    text: `occupation_position_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/occupationpositiontypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/occupationpositiontypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/occupationpositiontypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/occupationpositiontypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/occupationpositiontypes/:id`
                }
            },
            occupation_types: {
                menu: {
                    route: `${code}.occupation_types`,
                    text: `occupation_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/occupationtypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/occupationtypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/occupationtypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/occupationtypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/occupationtypes/:id`
                }
            },
            sector_types: {
                menu: {
                    route: `${code}.sector_types`,
                    text: `sector_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/sectortypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/sectortypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/sectortypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/sectortypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/sectortypes/:id`
                }
            },
            container_types: {
                menu: {
                    route: `${code}.container_types`,
                    text: `container_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/containertypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/containertypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/containertypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/containertypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/containertypes/:id`
                }
            },
            deed_owner_holder_end_types: {
                menu: {
                    route: `${code}.deed_owner_holder_end_types`,
                    text: `deed_owner_holder_end_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/deedownerholderendtypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/deedownerholderendtypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/deedownerholderendtypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/deedownerholderendtypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/deedownerholderendtypes/:id`
                }
            },
            deed_owner_holder_start_types: {
                menu: {
                    route: `${code}.deed_owner_holder_start_types`,
                    text: `deed_owner_holder_start_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/deedownerholderstarttypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/deedownerholderstarttypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/deedownerholderstarttypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/deedownerholderstarttypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/deedownerholderstarttypes/:id`
                }
            },
            interment_types: {
                menu: {
                    route: `${code}.interment_types`,
                    text: `interment_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/intermenttypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/intermenttypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/intermenttypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/intermenttypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/intermenttypes/:id`
                }
            },
            intervention_types: {
                menu: {
                    route: `${code}.intervention_types`,
                    text: `intervention_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/interventiontypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/interventiontypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/interventiontypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/interventiontypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/interventiontypes/:id`
                }
            },
            occupation_direction_types: {
                menu: {
                    route: `${code}.occupation_direction_types`,
                    text: `occupation_direction_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/occupationdirectiontypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/occupationdirectiontypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/occupationdirectiontypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/occupationdirectiontypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/occupationdirectiontypes/:id`
                }
            },
            occupation_right_types: {
                menu: { route: `${code}.occupation_right_types`, text: `occupation_right_types.titles`, icon: "fas fa-list" },
                acl: { view: false, detail: false, add: false, edit: false, delete: false, },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/occupationrighttypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/occupationrighttypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/occupationrighttypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/occupationrighttypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/occupationrighttypes/:id`
                }
            },
            remains_types: {
                menu: {
                    route: `${code}.remains_types`,
                    text: `remains_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/remainstypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/remainstypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/remainstypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/remainstypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/remainstypes/:id`
                }
            },
            religion_types: {
                menu: {
                    route: `${code}.religion_types`,
                    text: `religion_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/religiontypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/religiontypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/religiontypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/religiontypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/religiontypes/:id`
                }
            },

            occupation_state_types: {
                menu: {
                    route: `${code}.occupation_state_types`,
                    text: `occupation_state_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/occupationstatetypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/occupationstatetypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/occupationstatetypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/occupationstatetypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/occupationstatetypes/:id`
                }
            },
            occupation_service_need_types: {
                menu: {
                    route: `${code}.occupation_service_need_types`,
                    text: `occupation_service_need_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/occupationserviceneedtypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/occupationserviceneedtypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/occupationserviceneedtypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/occupationserviceneedtypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/occupationserviceneedtypes/:id`
                }
            },
            occupation_term_right_types: {
                menu: {
                    route: `${code}.occupation_term_right_types`,
                    text: `occupation_term_right_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: false,
                    detail: false,
                    add: false,
                    edit: false,
                    delete: false,
                },
                url: {
                    getList: `${codeAPI}/gestao/cemeteries/occupationtermrighttypes`,
                    getShow: `${codeAPI}/gestao/cemeteries/occupationtermrighttypes/:id`,
                    getCreate: `${codeAPI}/gestao/cemeteries/occupationtermrighttypes`,
                    getUpdate: `${codeAPI}/gestao/cemeteries/occupationtermrighttypes/:id`,
                    getDelete: `${codeAPI}/gestao/cemeteries/occupationtermrighttypes/:id`
                }
            },

        },
        tools: {}
    }
};

export default state;
